import React from 'react';
import i18n from 'i18next';
import { SearchField, Table } from 'Components';
import PropTypes from 'prop-types';
import './LoginAsAdminDesktop.css';

const LoginAsAdminDesktop = props => (
  <div className="login-as-admin__desktop">
    <SearchField
      placeholder={i18n.t('loginAsAdmin:Search Users')}
      title={i18n.t('loginAsAdmin:Enter Criteria (Name, UserName or ID)')}
      value={props.search}
      onChange={props.handleSearchChange}
    />
    <div className="login-as-admin__desktop__table">
      <Table {...props} />
    </div>
  </div>
);

LoginAsAdminDesktop.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  handleLoginAsAdmin: PropTypes.func,
  search: PropTypes.string,
  handleSearchChange: PropTypes.func,
};


export default LoginAsAdminDesktop;



// WEBPACK FOOTER //
// ./src/containers/LoginAsAdmin/LoginAsAdminDesktop/LoginAsAdminDesktop.jsx